// removed by extract-text-webpack-plugin
module.exports = {"compare":"compare__geYJe","compareFact":"compareFact__1ws1E","compareFactEven":"compareFactEven__2QJ-0","smallAtMobile":"smallAtMobile__2wSa-"};


//////////////////
// WEBPACK FOOTER
// ./components/TextComparison/style.css
// module id = 6ROg
// module chunks = 0